/**
 * WhiteLabelSubscriptions API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  checkWLFeature,
  checkWLLimit,
  getCurrentWLSubscription,
  getWLSubscriptionPlans,
  updateWLSubscriptionBillingEmail,
} from "../generated/white-label-subscriptions/white-label-subscriptions";

import { wrapMethod } from "./utils";

export const whiteLabelSubscriptions = {
  /** @see getCurrentWLSubscription */
  getCurrentWLSubscription: wrapMethod(getCurrentWLSubscription),

  /** @see getWLSubscriptionPlans */
  list: wrapMethod(getWLSubscriptionPlans),

  /** @see checkWLFeature */
  checkWLFeature: wrapMethod(checkWLFeature),

  /** @see checkWLLimit */
  checkWLLimit: wrapMethod(checkWLLimit),

  /** @see updateWLSubscriptionBillingEmail */
  update: wrapMethod(updateWLSubscriptionBillingEmail),
} as const;

export type WhiteLabelSubscriptionsApi = typeof whiteLabelSubscriptions;
